import {css, useTheme} from '@mui/material';
import {DlMuiChip, DlMuiDynamicIcon, GetStylesFunction} from '@wallaby-ui/core';
import * as React from 'react';

interface OwnProps {
  showEditButton: boolean | undefined;
  handleOnClick: () => void;
  showAlertIcon?: boolean;
  alertIconTitle?: string;
}

type Props = OwnProps;

export const EditIconWrapper: React.FC<Props> = (props) => {
  const {children, showEditButton, handleOnClick, showAlertIcon = false, alertIconTitle, ...restProps} = props;
  const theme = useTheme();
  const styles = getStyles({theme});

  return (
    <div {...restProps} css={styles.editIconWrapper}>
      {showAlertIcon && alertIconTitle ? (
        <DlMuiChip
          css={styles.chip}
          icon={
            <DlMuiDynamicIcon
              iconName={'alertIcon'}
              inputCss={styles.alertIcon}
              iconTitle={alertIconTitle}
              svgIconInputCss={styles.alertIcon}
              noButtonStyles
            />
          }
          label={alertIconTitle}
        />
      ) : (
        children
      )}
      {showEditButton && (
        <DlMuiDynamicIcon
          onClick={handleOnClick}
          inputCss={styles.editIcon}
          svgIconInputCss={styles.editIcon}
          iconName={'editIcon'}
          iconTitle={'patient.card.edit'}
          noButtonStyles
        />
      )}
    </div>
  );
};

EditIconWrapper.displayName = 'EditIconWrapper';

const getStyles: GetStylesFunction = (options) => ({
  editIconWrapper: css({
    display: 'flex',
    gap: `${options?.theme?.spacing(1)}`,
    justifyContent: 'center',
    alignItems: 'center',
  }),
  editIcon: css({
    'cursor': 'pointer',
    'width': '15px',
    'height': '14px',
    'color': 'var(--dlTheme-500)',
    '&:hover, &:focus': {
      color: 'var(--dlTheme-600)',
    },
    '&:active': {
      color: 'var(--dlTheme-700)',
    },
  }),
  chip: css`
    background-color: ${options?.theme?.palette.custom.alert['200']};
    color: var(--dlThemeGray-900);
  `,
  alertIcon: css({
    width: '12px',
    height: '12px',
    color: 'var(--dlThemeGray-900)',
  }),
});
